export const sizes = {
	w650: 650,
	w450: 450,
	w300: 300,
	w270: 270,
	w250: 250,
	w200: 200,
	w150: 150,
	h35: 35,
};
